import React, { useEffect } from 'react';
import { useStaticQuery,graphql } from 'gatsby';
import { Helmet } from 'react-helmet';

import Freshchat from './Freshchat';
import { Header } from './Header';
import { Footer } from './Footer';

import { buildCanonical } from 'utils';
import { useI18n } from 'context/I18nContext';


const query = graphql`
  query IntlQuery {
    site {
      siteMetadata {
        siteUrl
        intl {
          defaultLocale
          locales {
            path
            lcid
          }
        }
      }
    }
  }
`;

export const Layout: React.FC<{ locale: string }> = ({ children, locale }) => {

  const {
    site: {
      siteMetadata: { intl, siteUrl },
    },
  } = useStaticQuery(query);

  const { locale: currentLocale, setLocale } = useI18n();

  useEffect(() => {
    let isMounted = true;

    if (!isMounted && currentLocale === locale) return;
    setLocale(locale || 'en');

    return () => {
      isMounted = false;
    };
  }, [locale]);

  return (
    <>
      <Helmet>
        {intl.locales.map((lang: any) => {
          const href = buildCanonical(lang, intl.defaultLocale, siteUrl, '');
          return (
            <link
              key={lang.lcid}
              rel={lang.lcid === intl.defaultLocale ? 'canonical' : 'alternate'}
              href={href}
              hrefLang={lang.lcid}
            />
          );
        })}
      </Helmet>
      <Header />
      {children}
      <Footer />
      <Freshchat />
    </>
  );
};
